<template>
  <div class="book-start">
    <div class="brand">
      <div class="logo">
        <img src="@/assets/brand_hvit.svg" />
      </div>
    </div>
    <div class="wrapper">
      <div class="info-text">
        <p v-html="description"></p>
        <p><router-link title="Åpne boka" :to="{name: 'Page', params: { pageNumber: 1 }}">Åpne boka</router-link></p>
      </div>
      <div class="img">
          <router-link title="Åpne boka" :to="{name: 'Page', params: { pageNumber: 1 }}"><img v-if="book.coverAssetId" :src="previewUrl" /></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { assetApi } from 'api'
import bookTools from '@/utils/book'
export default {
  methods: {
  },
  computed: {
    book () {
      return this.$store.getters.book
    },
    previewUrl () {
      return assetApi.getPreviewUrl(this.book.coverAssetUrlPath, 'full')
    },
    description () {
      return bookTools.replaceLineBreaks(this.book.description || '')
    }
  }
}
</script>

<style lang="scss" scoped>
  .book-start {
    height: 100%;
    overflow: hidden;
    .brand {
      width: 75px;
      position: fixed;
      height: 100%;
      .logo {
        position: relative;
        margin-top: 20px;
        img {
          transform: rotate(270deg) translate(-100%);
          transform-origin: top left;
          height: 75px;
        }
      }
    }

    .wrapper {
      margin-left: 100px;
      display: flex;
      align-items: flex-end;
      height: 100%;

      .info-text {
        color: #FFF;
        height: 100%;
        padding: 20px 40px;
        width: 100%;
        margin-left: auto;
        p {
          margin-bottom: 20px;
          a {
            color: inherit;
          }
        }
      }

      .img {
        height: 100%;
        img {
          height: 100vh;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/book/BookStart.vue